<script setup>
import { ref, defineProps, onMounted } from 'vue'

const props = defineProps(['field'])
const field = ref(props.field)

const name = ref(null)
const crop = ref(null)
const manager = ref(null)

onMounted(() => {
  if (field.value) {
    name.value = field.value.Name
    crop.value = field.value.Crop
    manager.value = field.value.Manager
  }
})
</script>

<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-success text-white p-2">
        <h5 class="modal-title">
          <!-- <div v-if="field">{{ field.Name }}</div>
          <div v-else>新規登録</div> -->
          未実装

        </h5>
        <button type="button" class="btn-close btn-close-white pe-3" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label for="fieldName" class="form-label">圃場名</label>
          <input type="text" class="form-control" id="fieldName" placeholder="圃場名" v-model="name">
        </div>
        <div class="mb-3">
          <label for="fieldCrop" class="form-label">作物</label>
          <input type="text" class="form-control" id="fieldCrop" placeholder="作物" v-model="crop">
        </div>
        <div class="mb-3">
          <label for="fieldManager" class="form-label">担当</label>
          <input type="text" class="form-control" id="fieldManager" placeholder="担当" v-model="manager">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">閉じる</button>
        <button type="button" class="btn btn-primary" >保存</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
